import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const BusinessInfoStep = ({ formData, updateFormData, onNext }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  // Departamentos de Colombia
  const colombianDepartments = [
    'Amazonas', 'Antioquia', 'Arauca', 'Atlántico', 'Bolívar', 'Boyacá',
    'Caldas', 'Caquetá', 'Casanare', 'Cauca', 'Cesar', 'Chocó',
    'Córdoba', 'Cundinamarca', 'Guainía', 'Guaviare', 'Huila', 'La Guajira',
    'Magdalena', 'Meta', 'Nariño', 'Norte de Santander', 'Putumayo', 'Quindío',
    'Risaralda', 'San Andrés y Providencia', 'Santander', 'Sucre', 'Tolima',
    'Valle del Cauca', 'Vaupés', 'Vichada'
  ];

  // Municipios por departamento
  const municipiosByDepartment = {
    'Amazonas': ['Leticia', 'Puerto Nariño'],
    'Antioquia': ['Medellín', 'Bello', 'Itagüí', 'Envigado', 'Apartadó', 'Turbo', 'Rionegro', 'Sabaneta', 'Caldas', 'La Estrella'],
    'Arauca': ['Arauca', 'Arauquita', 'Cravo Norte', 'Fortul', 'Puerto Rondón', 'Saravena', 'Tame'],
    'Atlántico': ['Barranquilla', 'Soledad', 'Malambo', 'Sabanalarga', 'Puerto Colombia', 'Galapa', 'Baranoa', 'Palmar de Varela'],
    'Bolívar': ['Cartagena', 'Magangué', 'Turbaco', 'Arjona', 'El Carmen de Bolívar', 'Mompós', 'Turbana', 'Santa Rosa del Sur'],
    'Boyacá': ['Tunja', 'Duitama', 'Sogamoso', 'Chiquinquirá', 'Paipa', 'Villa de Leyva', 'Puerto Boyacá', 'Moniquirá'],
    'Caldas': ['Manizales', 'La Dorada', 'Chinchiná', 'Villamaría', 'Riosucio', 'Anserma', 'Palestina', 'Aguadas'],
    'Caquetá': ['Florencia', 'San Vicente del Caguán', 'Puerto Rico', 'El Doncello', 'El Paujil', 'La Montañita', 'Belén de los Andaquíes'],
    'Casanare': ['Yopal', 'Aguazul', 'Villanueva', 'Monterrey', 'Tauramena', 'Paz de Ariporo', 'Trinidad', 'Maní'],
    'Cauca': ['Popayán', 'Santander de Quilichao', 'Puerto Tejada', 'Patía', 'Corinto', 'Guapi', 'Miranda', 'Piendamó'],
    'Cesar': ['Valledupar', 'Aguachica', 'Bosconia', 'Codazzi', 'Curumaní', 'La Paz', 'Pelaya', 'San Diego'],
    'Chocó': ['Quibdó', 'Istmina', 'Condoto', 'Tadó', 'Acandí', 'Bahía Solano', 'Nuquí', 'Riosucio'],
    'Córdoba': ['Montería', 'Cereté', 'Lorica', 'Sahagún', 'Planeta Rica', 'Montelíbano', 'Tierralta', 'Ayapel'],
    'Cundinamarca': ['Bogotá', 'Soacha', 'Fusagasugá', 'Facatativá', 'Chía', 'Zipaquirá', 'Girardot', 'Cajicá', 'Madrid', 'Mosquera', 'Funza'],
    'Guainía': ['Inírida', 'Barranco Minas', 'Mapiripana', 'San Felipe', 'Puerto Colombia', 'La Guadalupe', 'Cacahual', 'Pana Pana'],
    'Guaviare': ['San José del Guaviare', 'Calamar', 'El Retorno', 'Miraflores'],
    'Huila': ['Neiva', 'Pitalito', 'Garzón', 'La Plata', 'Campoalegre', 'Gigante', 'Aipe', 'Algeciras'],
    'La Guajira': ['Riohacha', 'Maicao', 'Uribia', 'Manaure', 'San Juan del Cesar', 'Fonseca', 'Villanueva', 'Dibulla'],
    'Magdalena': ['Santa Marta', 'Ciénaga', 'Fundación', 'Plato', 'El Banco', 'Zona Bananera', 'Aracataca', 'Pivijay'],
    'Meta': ['Villavicencio', 'Acacías', 'Granada', 'Puerto López', 'San Martín', 'Cumaral', 'Restrepo', 'Puerto Gaitán'],
    'Nariño': ['Pasto', 'Tumaco', 'Ipiales', 'Túquerres', 'Samaniego', 'La Unión', 'Barbacoas', 'Sandoná'],
    'Norte de Santander': ['Cúcuta', 'Ocaña', 'Pamplona', 'Villa del Rosario', 'Los Patios', 'Tibú', 'El Zulia', 'Chinácota'],
    'Putumayo': ['Mocoa', 'Puerto Asís', 'Orito', 'Valle del Guamuez', 'Puerto Guzmán', 'Villagarzón', 'San Miguel', 'Sibundoy'],
    'Quindío': ['Armenia', 'Calarcá', 'La Tebaida', 'Montenegro', 'Quimbaya', 'Circasia', 'Filandia', 'Salento'],
    'Risaralda': ['Pereira', 'Dosquebradas', 'Santa Rosa de Cabal', 'La Virginia', 'Marsella', 'Belén de Umbría', 'Apía', 'Santuario'],
    'San Andrés y Providencia': ['San Andrés', 'Providencia'],
    'Santander': ['Bucaramanga', 'Floridablanca', 'Girón', 'Piedecuesta', 'Barrancabermeja', 'San Gil', 'Socorro', 'Málaga'],
    'Sucre': ['Sincelejo', 'Corozal', 'Sampués', 'Tolú', 'Coveñas', 'Majagual', 'San Marcos', 'Sincé'],
    'Tolima': ['Ibagué', 'Espinal', 'Melgar', 'Honda', 'Líbano', 'Chaparral', 'Mariquita', 'Purificación'],
    'Valle del Cauca': ['Cali', 'Palmira', 'Buenaventura', 'Tuluá', 'Cartago', 'Buga', 'Jamundí', 'Yumbo', 'Candelaria'],
    'Vaupés': ['Mitú', 'Carurú', 'Taraira'],
    'Vichada': ['Puerto Carreño', 'La Primavera', 'Santa Rosalía', 'Cumaribo']
  };

  const businessCategories = [
    { value: 'restaurantes', label: 'Restaurantes y Cafés' },
    { value: 'moda', label: 'Moda y Accesorios' },
    { value: 'salud', label: 'Salud y Belleza' },
    { value: 'tecnologia', label: 'Tecnología y Electrónica' },
    { value: 'servicios', label: 'Servicios Profesionales' },
    { value: 'entretenimiento', label: 'Entretenimiento' },
    { value: 'deportes', label: 'Deportes y Fitness' },
    { value: 'educacion', label: 'Educación' },
    { value: 'hogar', label: 'Hogar y Decoración' },
    { value: 'automotriz', label: 'Automotriz' },
    { value: 'otro', label: 'Otro' }
  ];

  // Obtener municipios del departamento seleccionado
  const getMunicipios = () => {
    if (!formData?.department) return [];
    return municipiosByDepartment?.[formData?.department] || [];
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.legalName?.trim()) {
      newErrors.legalName = 'La razón social es requerida';
    }

    if (!formData?.commercialName?.trim()) {
      newErrors.commercialName = 'El nombre comercial es requerido';
    }

    if (!formData?.nit?.trim()) {
      newErrors.nit = 'El NIT es requerido';
    } else if (!/^[0-9]{9,10}-[0-9]$/?.test(formData?.nit)) {
      newErrors.nit = 'Formato inválido. Ejemplo: 900123456-7';
    }

    if (!formData?.category) {
      newErrors.category = 'Selecciona una categoría';
    }

    if (!formData?.description?.trim()) {
      newErrors.description = 'La descripción es requerida';
    } else if (formData?.description?.length < 50) {
      newErrors.description = 'La descripción debe tener al menos 50 caracteres';
    }

    if (!formData?.address?.trim()) {
      newErrors.address = 'La dirección es requerida';
    }

    if (!formData?.contactEmail?.trim()) {
      newErrors.contactEmail = 'El correo electrónico es requerido';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.contactEmail)) {
      newErrors.contactEmail = 'Correo electrónico inválido';
    }

    if (formData?.contactEmail !== formData?.confirmContactEmail) {
      newErrors.confirmContactEmail = 'Los correos electrónicos no coinciden';
    }

    if (!formData?.password) {
      newErrors.password = 'La contraseña es requerida';
    } else if (formData?.password?.length < 8) {
      newErrors.password = 'Mínimo 8 caracteres';
    }

    if (formData?.password !== formData?.confirmPassword) {
      newErrors.confirmPassword = 'Las contraseñas no coinciden';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateForm()) {
      onNext();
    }
  };

  const formatNIT = (value) => {
    const cleaned = value?.replace(/\D/g, '');
    if (cleaned?.length <= 10) {
      const main = cleaned?.substring(0, cleaned?.length - 1);
      const verifier = cleaned?.substring(cleaned?.length - 1);
      return verifier ? `${main}-${verifier}` : main;
    }
    return value;
  };

  // Manejar cambio de departamento (resetear municipio)
  const handleDepartmentChange = (value) => {
    updateFormData({ 
      department: value,
      municipality: '' // Resetear municipio cuando cambia departamento
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">Información del Negocio</h2>
        <p className="text-muted-foreground">Proporciona los datos principales de tu empresa</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Razón Social"
          required
          placeholder="Ej: Comercializadora ABC S.A.S."
          value={formData?.legalName || ''}
          onChange={(e) => updateFormData({ legalName: e?.target?.value })}
          error={errors?.legalName}
          description="Nombre legal registrado de tu empresa"
        />

        <Input
          label="Nombre Comercial"
          required
          placeholder="Ej: ABC Store"
          value={formData?.commercialName || ''}
          onChange={(e) => updateFormData({ commercialName: e?.target?.value })}
          error={errors?.commercialName}
          description="Nombre público de tu negocio"
        />
      </div>
      <Input
        label="NIT"
        required
        placeholder="900123456-7"
        value={formData?.nit || ''}
        onChange={(e) => {
          const formatted = formatNIT(e?.target?.value);
          updateFormData({ nit: formatted });
        }}
        error={errors?.nit}
        description="Número de Identificación Tributaria con dígito de verificación"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Categoría Principal"
          required
          value={formData?.category || ''}
          onChange={(value) => updateFormData({ category: value })}
          error={errors?.category}
          options={businessCategories}
        />

        <Input
          label="Subcategoría"
          placeholder="Ej: Comida rápida, Ropa deportiva, etc."
          value={formData?.subcategory || ''}
          onChange={(e) => updateFormData({ subcategory: e?.target?.value })}
          description="Especifica tu nicho de mercado (opcional)"
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground">
          Descripción del Negocio <span className="text-destructive">*</span>
        </label>
        <textarea
          className="flex min-h-[120px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none"
          placeholder="Describe tu negocio, productos o servicios que ofreces, y lo que te hace único..."
          value={formData?.description || ''}
          onChange={(e) => updateFormData({ description: e?.target?.value })}
          maxLength={500}
        />
        <div className="flex justify-between items-center text-xs">
          {errors?.description ? (
            <p className="text-destructive flex items-center gap-1">
              <Icon name="AlertCircle" size={12} />
              {errors?.description}
            </p>
          ) : (
            <p className="text-muted-foreground">Mínimo 50 caracteres</p>
          )}
          <p className="text-muted-foreground">
            {formData?.description?.length || 0}/500 caracteres
          </p>
        </div>
      </div>
      <div className="border-t pt-6">
        <h3 className="text-lg font-bold text-foreground mb-4 flex items-center gap-2">
          <Icon name="MapPin" size={20} className="text-accent" />
          Ubicación
        </h3>

        <Input
          label="Dirección Completa"
          required
          placeholder="Calle 123 #45-67"
          value={formData?.address || ''}
          onChange={(e) => updateFormData({ address: e?.target?.value })}
          error={errors?.address}
          description="Dirección física del establecimiento"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          <Select
            label="Departamento"
            required
            value={formData?.department || ''}
            onChange={handleDepartmentChange}
            options={colombianDepartments?.map(dept => ({ value: dept, label: dept }))}
            placeholder="Selecciona departamento"
          />

          <Select
            label="Municipio"
            required
            value={formData?.municipality || ''}
            onChange={(value) => updateFormData({ municipality: value })}
            options={getMunicipios()?.map(m => ({ value: m, label: m }))}
            error={errors?.municipality}
            disabled={!formData?.department}
          />

          <Input
            label="Barrio"
            placeholder="Ej: El Poblado"
            value={formData?.neighborhood || ''}
            onChange={(e) => updateFormData({ neighborhood: e?.target?.value })}
          />
        </div>
      </div>
      <div className="border-t pt-6">
        <h3 className="text-lg font-bold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Lock" size={20} className="text-primary" />
          Configuración de Seguridad
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Contraseña"
            type="password"
            required
            placeholder="Mínimo 8 caracteres"
            value={formData?.password || ''}
            onChange={(e) => updateFormData({ password: e?.target?.value })}
            error={errors?.password}
          />

          <Input
            label="Confirmar Contraseña"
            type="password"
            required
            placeholder="Repite tu contraseña"
            value={formData?.confirmPassword || ''}
            onChange={(e) => updateFormData({ confirmPassword: e?.target?.value })}
            error={errors?.confirmPassword}
          />
        </div>
      </div>
      <div className="border-t pt-6">
        <h3 className="text-lg font-bold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Mail" size={20} className="text-accent" />
          Correo Electrónico de Contacto
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Correo Electrónico"
            type="email"
            required
            placeholder="contacto@tunegocio.com"
            value={formData?.contactEmail || ''}
            onChange={(e) => updateFormData({ contactEmail: e?.target?.value })}
            error={errors?.contactEmail}
            description="Correo para verificación y comunicaciones"
          />

          <Input
            label="Confirmar Correo Electrónico"
            type="email"
            required
            placeholder="contacto@tunegocio.com"
            value={formData?.confirmContactEmail || ''}
            onChange={(e) => updateFormData({ confirmContactEmail: e?.target?.value })}
            error={errors?.confirmContactEmail}
          />
        </div>
      </div>
      <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-blue-900">
            <p className="font-semibold mb-1">Información verificable</p>
            <p>Toda la información proporcionada será verificada por nuestro equipo. Asegúrate de que los datos sean correctos y coincidan con tus documentos legales.</p>
          </div>
        </div>
      </div>
      <div className="pt-6 border-t">
        <Button
          type="submit"
          variant="default"
          size="lg"
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
          className="bg-gradient-to-r from-accent to-orange-600 hover:shadow-lg transform hover:scale-105 transition-all"
        >
          Continuar al Siguiente Paso
        </Button>
      </div>
      <div className="text-center pt-4 border-t">
        <p className="text-sm text-muted-foreground">
          ¿Ya tienes una cuenta comercial?{' '}
          <button
            type="button"
            onClick={() => navigate('/business-login')}
            className="text-accent font-semibold hover:underline cursor-pointer bg-transparent border-none"
          >
            Inicia Sesión
          </button>
        </p>
      </div>
    </form>
  );
};

export default BusinessInfoStep;